Monitoring.Views ||= {}
class AccountSettings.MarketingAccountSelectionView extends Backbone.View
  template: JST["backbone/templates/account_settings/topics/marketing_account_selection"]
  events:
    'click .remove-selection': 'onRemoveSelection'
  tagName: 'div'
  className: 'selected_marketing_account'

  initialize: (@options = {}) ->
    @account = @options.marketingAccount
    @sourceIndex = @options.sourceIndex

  render: =>
    @$el.html(@template({accountName: @account.accountName, accountId: @account.accountId, sourceIndex: @sourceIndex}))
    @

  onRemoveSelection:->
    @trigger('selection:remove', @)
